import React, { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getCompanys, getEmployee } from '../../services/dataService';
import Breadcrumb from '../../components/common/Breadcrumb';
import toast from 'react-hot-toast';
import { getSecureItem } from '../../services/SecureStorage';

function IncrementReport() {
  const UID = getSecureItem("userId");
  const [employeeList, setEmployeeList] = useState([]);
  const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedmonth, setSelectedMonth] = useState()
  const [datafilter, setDatefilter] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [selectedValue, setSelectedValue] = useState("");

  const CategorySelectOptions = filteredEmployeeList.map((el) => el.CategoryName);


  useEffect(() => {
    console.log(CategorySelectOptions, 'sssssssssss');

  }, [datafilter])

  const handleCategoryChange = (event) => {
    const selectedValue = event.target.value; // Get the selected value from the event
    const filtered = filteredEmployeeList.filter(el => el.CategoryName === selectedValue);
    console.log(filtered, 'Filtered List');
    setDatefilter(filtered); // Update the state
  };

  const handleClear = () => {
    setSelectedValue(""); // Clear the selected value
    setDatefilter(filteredEmployeeList); // Reset the filter
  };


  const getEmployeeList = async () => {
    try {
      const response = await getEmployee(UID);
      // Filter employees with non-null IncrementDate
      const filteredEmployees = response.data.data.filter(
        employee => employee.IncrementDate !== null
      );
      // Set the original list to the full data
      setEmployeeList(response.data.data);

      // Set the filtered list to the filtered data
      setFilteredEmployeeList(filteredEmployees);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setLoading(false);
    }
  };



  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0])
      console.log(response.data.data[0], 'Respocsdnse Data');

    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails()
  }, [])

  useEffect(() => {
    getEmployeeList();
  }, []);


  useEffect(() => {
    setDatefilter(filteredEmployeeList)
  }, [filteredEmployeeList])

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter employees based on search term AND ensure IncrementDate is not null
    const filtered = employeeList?.filter(employee =>
      (employee.Name?.toLowerCase().includes(value) ||
        employee.Code?.toLowerCase().includes(value) ||
        employee.DepartmentName?.toLowerCase().includes(value) ||
        employee.DesignationName?.toLowerCase().includes(value)) &&
      employee.IncrementDate !== null
    );

    setFilteredEmployeeList(filtered);
  };

  const downloadIncrementReports = () => {
    const doc = new jsPDF('landscape', 'mm', 'a4');

    if (!datafilter || datafilter.length === 0) {
      toast.error('No Data');
      return;
    }

    // Document properties
    doc.setProperties({
      title: 'Increment Report',
      creator: 'Your Company',
      keywords: 'increment, report, employee'
    });

    // Header with company name
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0); // Pure black
    doc.text(companyDetails.Name, doc.internal.pageSize.width / 2, 18, { align: 'center' });

    // Subtitle
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Increment Report', doc.internal.pageSize.width / 2, 24, { align: 'center' });

    // Thin divider line
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(20, 27, doc.internal.pageSize.width - 20, 27);

    // Metadata
    doc.setFontSize(9);
    const currentDate = new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
    doc.text(`Generated: ${currentDate}`, 20, 34);
    doc.text(`Page ${doc.internal.getNumberOfPages()}`, doc.internal.pageSize.width - 20, 34, { align: 'right' });

    // Prepare table data
    const tableData = datafilter
      ?.filter(employee => employee.IncrementDate && employee.IncrementDate.length > 0)
      .map(employee => [
        employee.Code || 'N/A',
        employee.Name || 'N/A',
        employee.DepartmentName || 'N/A',
        employee.DesignationName || 'N/A',
        employee.IncrementDate ? new Date(employee.IncrementDate).toLocaleDateString('en-GB') : 'N/A',
        employee.IncrimentDateBeforUpdate ? new Date(employee.IncrimentDateBeforUpdate).toLocaleDateString('en-GB') : 'N/A'
      ]);

    // Column width calculation for 6 columns
    const pageWidth = doc.internal.pageSize.width - 40;
    const columnCount = 6; // Fixed: Changed from 5 to 6
    const columnWidth = pageWidth / columnCount;

    // Clean table with white background throughout
    doc.autoTable({
      startY: 37,
      head: [['Employee Code', 'Name', 'Department', 'Designation', 'Increment Date','Updated Increment Date']],
      body: tableData,
      theme: 'grid',
      styles: {
        font: 'Helvetica',
        fontSize: 9,
        textColor: [0, 0, 0], // Black text
        cellPadding: 3,
        lineColor: [220, 220, 220], // Light gray lines
        lineWidth: 0.2,
        minCellHeight: 6,
      },
      headStyles: {
        fillColor: [255, 255, 255], // White background
        textColor: [0, 0, 0], // Black text
        fontStyle: 'bold',
        lineWidth: 0.3,
        halign: 'center',
        valign: 'middle',
        minCellHeight: 8
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White background
        textColor: [0, 0, 0], // Black text
        lineWidth: 0.2,
        valign: 'middle'
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255] // No alternate coloring
      },
      columnStyles: {
        0: { cellWidth: columnWidth, halign: 'center' },
        1: { cellWidth: columnWidth, halign: 'left' },
        2: { cellWidth: columnWidth, halign: 'left' },
        3: { cellWidth: columnWidth, halign: 'left' },
        4: { cellWidth: columnWidth, halign: 'center' },
        5: { cellWidth: columnWidth, halign: 'center' } // Added missing 6th column
      },
      margin: { top: 37, left: 20, right: 20 },
      tableWidth: 'wrap',
      didDrawPage: (data) => {
        // Minimal footer
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text(
          `© ${new Date().getFullYear()} ${companyDetails.Name}`,
          doc.internal.pageSize.width / 2,
          doc.internal.pageSize.height - 10,
          { align: 'center' }
        );
      }
    });

    doc.save('Increment_Report.pdf');
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-blue-500"></div>
      </div>
    );
  }


  const handleshow = () => {
    console.log(selectedmonth, 'Selected Month');
    console.log(filteredEmployeeList, 'Filtered Employee List');

    // Filtering employees based on the selected month
    const MatchedData = filteredEmployeeList.filter(el =>
      el.IncrementDate.split('T')[0].slice(0, 7) == selectedmonth
    );

    // Setting the date filter
    setDatefilter(MatchedData);

    console.log(MatchedData, 'Matched Data');
  };

  const clearMonth = () => {
    setSelectedMonth('')
    setDatefilter(filteredEmployeeList)
  }

  return (
    <div className="container mx-auto p-6">
      <div className="flex flex-col md:flex-row gap-4 md:gap-[40px] w-full mb-4 md:mb-0">
        <Breadcrumb title="Increment Reports " />
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="p-6 bg-gray-50 border-b border-gray-200">

          {/* Search Input and Button on Same Line */}
          <div className="flex items-center justify-between mb-4 gap-4">
            <input
              type="text"
              placeholder="Search by Name, Code, Department, or Designation"
              value={searchTerm}
              onChange={handleSearch}
              className="flex-1 max-w-[400px] p-2 border rounded"
            />

            <div className="flex items-center gap-2 flex-1 justify-center">
              <input
                type="month"
                value={selectedmonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="py-2 px-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              />

              <button
                onClick={handleshow}
                className='btn btn-primary'              >
                Show
              </button>

              <button
                onClick={clearMonth}
                className="px-4 py-2 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 "
              >
                Clear
              </button>
            </div>

            <button
              onClick={downloadIncrementReports}
              className="btn btn-success flex-1 max-w-[250px]"
              disabled={filteredEmployeeList.length === 0}
            >
              Download Increment Report
            </button>
            <div className="relative mt-[-20px]">
              <label htmlFor="categorySelect" className="block text-sm font-medium text-gray-700 mb-1">
                Filter by Category
              </label>
              <div className="flex items-center space-x-4">
                <select
                  id="categorySelect"
                  value={selectedValue} // Controlled component
                  onChange={handleCategoryChange} // Corrected handler
                  className="block   w-[400px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                >
                  <option disabled value="">
                    Select Category
                  </option>
                  {CategorySelectOptions.map((el, index) => (
                    <option key={index} value={el}>
                      {el}
                    </option>
                  ))}
                </select>
                <button onClick={handleClear} className="btn btn-danger">
                  Clear
                </button>
              </div>
            </div>



          </div>

          {datafilter?.length === 0 ? (
            <div className="p-6 text-center text-gray-500">
              No increment data available
            </div>
          ) : (
            <div className="overflow-auto max-h-[400px]">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-3 text-left">Employee Code</th>
                    <th className="p-3 text-left">Name</th>  
                    <th className="p-3 text-left">Department</th>
                    <th className="p-3 text-left">Designation</th>
                    <th className="p-3 text-left"> Updated Increment Date</th>
                    <th className="p-3 text-left">Increment Date</th>

                  </tr>
                </thead>
                <tbody>
                  {datafilter?.map((employee) => (
                    <tr key={employee.Id} className="border-b hover:bg-gray-50">
                      <td className="p-3">{employee.Code}</td>
                      <td className="p-3">{employee.Name}</td>
                      <td className="p-3">{employee.DepartmentName}</td>
                      <td className="p-3">{employee.DesignationName}</td>
                      <td className="p-3">
                        {employee.IncrementDate
                          ? new Date(employee.IncrementDate).toLocaleDateString('en-GB') // 'en-GB' formats the date as dd/mm/yyyy
                          : 'N/A'}
                      </td>
                      <td className="p-3">
                        {employee.IncrimentDateBeforUpdate
                          ? new Date(employee.IncrimentDateBeforUpdate).toLocaleDateString('en-GB') // 'en-GB' formats the date as dd/mm/yyyy
                          : 'N/A'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>

  );
}

export default IncrementReport;